import {
  Button,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import emptyIcon from "../../../assets/images/Icons/search-table.png";
import React, { useRef } from "react";
import { CustomTable, InputControl } from "../../../shared";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { createColumnHelper } from "@tanstack/react-table";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { StyledDropzone } from "../../../shared/components/StyledDropzone";
import imageIcon from "../../../assets/images/Icons/icons8_video_clip 1.svg";
import CloseIcon from "@mui/icons-material/Close";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

export const HowtoPrepare = React.forwardRef((props, ref) => {
  const {
    validator,
    handleQuillChange,
    state,
    handleDropzone,
    stepsHandleDelete,
    handleDropzoneVideo,
    handleDeleteVideos,
    handleKeyDown,
    setVideoUrl,
    onClearVideoUrl,
    createVideoUrl,
    removeImage,
    handleStepChange,
    handleDragEnd,
    addStepChangeHandler,
  } = props;

  const { steps, videos, method } = state.data;

  const videoRef = useRef();

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [
        {
          color: [],
        },
      ],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
  ];

  const addVideoHandler = () => {
    videoRef.current.click();
  };

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("video_url", {
      header: () => "Video",
      enableSorting: false,
      cell: (info) => {
        const name = info?.row?.original?.video_name;
        const videoUrl = info?.row?.original?.video_url;
        return (
          <Stack borderRadius="10px" direction="row" gap="10px">
            <img src={imageIcon} alt="video_icon" />
            <div>{name ?? videoUrl}</div>
          </Stack>
        );
      },
    }),

    columnHelper.accessor("id", {
      header: "",
      align: "right",
      cell: (info) => {
        return (
          <Button
            type="button"
            size="small"
            variant="text"
            color="error"
            onClick={() => handleDeleteVideos(info.row.index)}
          >
            remove
          </Button>
        );
      },
    }),
  ];
  return (
    <Stack>
      <Stack
        sx={{ py: "32px", borderBottom: "1px solid", borderColor: "divider" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ width: "150px" }}
            >
              Method
            </Typography>
          </Grid>
          <Grid item sm={8}>
            <ReactQuill
              style={{ minHeight: "158px" }}
              theme="snow"
              name="method"
              modules={modules}
              formats={formats}
              value={method}
              onChange={(value) => handleQuillChange("method", value)}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack
        sx={{ py: "32px", borderBottom: "1px solid", borderColor: "divider" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ width: "150px" }}
            >
              How to Prepare
            </Typography>
          </Grid>

          <Grid item sm={8}>
            {/* <Stack width="100%"> */}
            {validator.current.purgeFields()}
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="stepsDroppable">
                {(provided) => (
                  <TableContainer
                    component={Paper}
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    sx={{
                      backgroundColor: "#F5F8FC",
                      borderRadius: 0,
                    }}
                  >
                    <Table
                      sx={{ mx: "8px", mb: "8px", width: "calc(100% - 16px)" }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Image</TableCell>
                          <TableCell>Steps</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ border: 1, borderColor: "divider" }}>
                        {steps.length === 0 ? (
                          <TableRow>
                            <TableCell align="center" colSpan={3} height={162}>
                              <Stack alignItems="center" gap="8px">
                                <img
                                  src={emptyIcon}
                                  alt="empty"
                                  height={56}
                                  width={56}
                                />
                                <Typography
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#485364",
                                  }}
                                >
                                  No data found
                                </Typography>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ) : (
                          <>
                            {steps.map((row, index) => (
                              <Draggable
                                key={index.toString()}
                                draggableId={index.toString()}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <TableRow
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    style={{
                                      backgroundColor: snapshot.isDragging
                                        ? "#f0f0f0"
                                        : "inherit",
                                      ...provided.draggableProps.style,
                                    }}
                                    sx={{
                                      border: "1px solid",
                                      borderColor: "divider",
                                    }}
                                  >
                                    <TableCell {...provided.dragHandleProps}>
                                      <DragIndicatorIcon
                                        sx={{
                                          cursor: "grab",
                                          alignSelf: "center",
                                        }}
                                      />
                                    </TableCell>

                                    <TableCell>
                                      <StyledDropzone
                                        maxFiles={1}
                                        loading={row.loading}
                                        handleDropzone={(event) =>
                                          handleDropzone(event, index)
                                        }
                                        imgUrl={
                                          row.imageFile
                                            ? URL.createObjectURL(row.imageFile)
                                            : row.image_url || ""
                                        }
                                        removeImage={() => removeImage(index)}
                                      />
                                    </TableCell>

                                    <TableCell>
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                      >
                                        <Stack width="100%">
                                          <ReactQuill
                                            theme="snow"
                                            modules={modules}
                                            formats={formats}
                                            value={row.step}
                                            onChange={(value) =>
                                              handleStepChange(value, index)
                                            }
                                          />
                                          <FormHelperText
                                            sx={{ color: "#C60808" }}
                                          >
                                            {validator.current.message(
                                              `step-${index + 1}`,
                                              row.formattedStep?.trim(),
                                              "required",
                                            )}
                                          </FormHelperText>
                                        </Stack>

                                        <IconButton
                                          sx={{
                                            color: "#B42318",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            stepsHandleDelete(index)
                                          }
                                        >
                                          <RemoveCircleIcon />
                                        </IconButton>
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </>
                        )}
                      </TableBody>
                      <TableFooter
                        sx={{
                          backgroundColor: "#FFFFFF",
                          border: 1,
                          borderColor: "divider",
                        }}
                      >
                        <TableRow>
                          <TableCell colSpan={3} align="left">
                            <Button
                              type="button"
                              size="small"
                              variant="text"
                              startIcon={<AddIcon />}
                              onClick={addStepChangeHandler}
                            >
                              Add Step
                            </Button>
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                )}
              </Droppable>
            </DragDropContext>
            {/* </Stack> */}
          </Grid>
        </Grid>
      </Stack>

      <Stack sx={{ py: "32px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle1" fontWeight={600}>
              Recipe Preparation Video
            </Typography>
          </Grid>
          <Grid item sm={8}>
            <CustomTable
              defaultData={videos}
              columns={columns}
              emptyTableMessage="There is no videos added yet, You need to add videos first"
              isPagination={false}
              isTableHeader={false}
              isLoading={createVideoUrl.isPending}
              tableFooter={
                <Stack
                  direction="row"
                  alignItems="center"
                  gap={2}
                  border={1}
                  borderTop={0}
                  mx="8px"
                  mb="8px"
                  p="8px"
                  sx={{ backgroundColor: "#FFFFFF", borderColor: "divider" }}
                >
                  <div>
                    <Button
                      type="button"
                      size="small"
                      variant="text"
                      startIcon={<AddIcon />}
                      onClick={(event) => addVideoHandler(event, videos.length)}
                    >
                      Add Files
                    </Button>
                    <input
                      id="contained-button-file"
                      type="file"
                      onChange={(e) => handleDropzoneVideo(e)}
                      style={{ display: "none" }}
                      ref={videoRef}
                    />
                  </div>

                  <Typography color="#C4CFE4">/</Typography>

                  <InputControl
                    placeholder="Or add a video link"
                    type="text"
                    variant="standard"
                    name="videoUrl"
                    value={state.videoUrl}
                    onChange={(e) => setVideoUrl(e)}
                    onKeyDown={handleKeyDown}
                    size="small"
                    hiddenLabel
                    sx={{ my: 0 }}
                    InputProps={{
                      sx: {
                        borderRadius: "15px",
                        backgroundColor: "#F5F8FC",
                        outline: 1,
                        outlineColor: "divider",
                        px: "14px",
                      },
                      disableUnderline: true,
                      startAdornment: (
                        <InputAdornment position="start">
                          <img alt="upOrDown" src="/icons/link.svg" />
                        </InputAdornment>
                      ),
                      endAdornment: state.videoUrl && (
                        <InputAdornment
                          sx={{ cursor: "pointer" }}
                          onClick={onClearVideoUrl}
                          position="end"
                        >
                          <CloseIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
              }
            />
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
});
